import { useTranslation } from 'react-i18next';
import { countries } from '../../../mocks/countries';

export default function Countries() {
  const { t } = useTranslation();
  return (
    <section id="countries" className="bg-bg">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-18">
        <div className="text-center mb-8">
          <h2 className="text-[24px] md:text-[28px] font-bold tracking-tight">{t('countries.section.title')}</h2>
          <p className="mt-2 text-[15px] text-muted">
            {t('countries.section.subtitle')}
          </p>
        </div>
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {countries.map((country) => (
            <li key={country.code}>
              <a
                href={country.path}
                className="group flex flex-col items-center rounded-xl border border-border bg-surface p-5 transition hover:border-primary hover:bg-primary-soft cursor-pointer"
              >
                <img
                  src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/${country.flagCode}.svg`}
                  alt={`${t(`countries.${country.key}.name`)} flag`}
                  width={48}
                  height={36}
                  loading="lazy"
                  className="rounded-sm"
                />
                <div className="mt-3 text-[16px] font-semibold text-ink">{t(`countries.${country.key}.name`)}</div>
                <div className="mt-1 text-[12px] text-muted">{t(`countries.${country.key}.operator`)}</div>
                <div className="mt-4 inline-flex items-center gap-1 rounded-md bg-primary px-4 py-2 text-[13px] font-semibold text-white transition group-hover:bg-primary-hover">
                  <span>{t('countries.getVignette')}</span>
                  <span>→</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
